import React from 'react';
import { PTPApp } from './pages/PTPApp';
export function App() {
  return <div className="min-h-screen w-full bg-black flex items-center justify-center" data-id="element-0">
      {/* Mobile device simulator container */}
      <div className="w-full max-w-[430px] h-[100dvh] md:h-[900px] md:max-h-[95vh] bg-white md:rounded-[40px] md:border-[8px] border-gray-200 overflow-hidden relative shadow-2xl shadow-gray-300/30 flex flex-col" data-id="element-1">
        {/* Fake mobile status bar — color controlled by --status-bar-bg CSS var */}
        <div className="absolute top-0 left-0 right-0 h-7 flex justify-center items-end pb-1 z-[60] pointer-events-none transition-colors duration-300" style={{
        backgroundColor: 'var(--status-bar-bg, transparent)'
      }} data-id="element-2">
          <div className="w-1/3 h-1.5 rounded-full" style={{
          backgroundColor: 'var(--status-bar-pill, rgba(0,0,0,0.2))'
        }} data-id="element-3"></div>
        </div>

        {/* Main App — includes top padding for status bar */}
        <div className="flex-1 overflow-hidden relative pt-7" data-id="element-4">
          <PTPApp data-id="element-5" />
        </div>

        {/* Fake mobile home indicator */}
        <div className="h-6 w-full bg-white flex justify-center items-center z-50" data-id="element-6">
          <div className="w-1/3 h-1 bg-gray-300 rounded-full" data-id="element-7"></div>
        </div>
      </div>
    </div>;
}